<template>
  <div class="product-pictures" v-if="!loading && phone">
    <div class="main-picture">
      <div class="picture">
        <img :src="currentPicture" :alt="phone.name" v-if="currentPicture">
      </div>
    </div>
    <div class="picture-list" v-if="phone.pictures.length">
      <div class="picture" :class="{ 'active': (currentPicture === picture)}" v-for="(picture, index) in phone.pictures" :key="index" @click="selectPicture(picture)">
        <img :src="picture" :alt="phone.name">
      </div>
    </div>
    <div class="product-colors">
      <ul>
        <li class="color" @click.prevent="selectColor(color)" :class="{ 'active': (phone.defaults.color.id === color.id) }" v-for="(color, index) in phone.colors" :key="index" :style="{ backgroundColor: '#' + color.hex }">
          <span class="check" :style="{ color: foregroundColor('#' + color.hex) }"></span>
        </li>
      </ul>
    </div>
  </div>
  <div class="product-pictures" v-else>
    <div class="main-picture">
      <div class="picture picture-load"><div class="mark"></div></div>
    </div>
    <div class="picture-list">
      <div class="picture picture-load"><div class="mark"></div></div>
      <div class="picture picture-load"><div class="mark"></div></div>
      <div class="picture picture-load"><div class="mark"></div></div>
      <div class="picture picture-load"><div class="mark"></div></div>
      <div class="picture picture-load"><div class="mark"></div></div>
    </div>
  </div>
</template>

<script>
import { contrastColor } from 'contrast-color'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Pictures',
  props: {
    loading: Boolean
  },
  data () {
    return {
      currentPicture: null
    }
  },
  computed: {
    ...mapState({
      phone: state => state.phone.item,
      load: state => state.phone.load
    })
  },
  methods: {
    ...mapActions('phone', ['setColor']),
    selectPicture (picture) {
      this.currentPicture = picture
    },
    foregroundColor (color) {
      return contrastColor({ bgColor: color })
    },
    selectColor(color) {
      this.setColor(color)
    }
  },
  watch: {
    phone () {
      if(this.phone.pictures && this.phone.pictures.length) {
        this.currentPicture = this.phone.pictures[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

@keyframes slide {
  0% { @include transform(translateX(-50%) translateY(-200%) translateZ(0)); }
  100% { @include transform(translateX(-50%) translateY(200%) translateZ(0)); }
}

.mark{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  animation: slide 1s linear infinite;
  background: rgb(15,242,32);
  background: linear-gradient(0deg, rgba(darken(#f9f9f9, 3%), 1) 0%, rgba(darken(#f9f9f9, 6%), 1) 50%, rgba(darken(#f9f9f9, 3%), 1) 100%);
  @include transform(translateX(-50%) translateY(-50%) translateZ(0));
}

.product-pictures{

  @include responsive(mobile) {
    display: grid;
    grid-template-columns: 50px 1fr;
    grid-column-gap: 10px;
  }

  .main-picture{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    @include responsive(mobile) {
      order: 2;
    }

    .picture{
      max-width: 500px;
      min-height: 450px;
      padding: 30px;
      background-color: $white;
      position: relative;
      overflow: hidden;
      text-align: center;
      @include radius(10px);

      @include responsive(mobile) {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 300px;
      }

      &.picture-load{
        background-color: darken(#f9f9f9, 3%);
      }

      img{
        max-width: 100%;
        height: auto;
      }
    }
  }

  .picture-list{
    text-align: center;

    @include responsive(mobile) {
      order: 1;
    }

    .picture{
      display: inline-block;
      float: none;
      width: 70px;
      height: 70px;
      margin: 0 5px;
      padding: 10px;
      text-align: center;
      line-height: 50px;
      background-color: $white;
      border: 2px solid $white;
      cursor: pointer;
      overflow: hidden;
      position: relative;
      @include radius(10px);
      @include transition();

      @include responsive(mobile) {
        width: 50px;
        height: 50px;
        line-height: 40px;
        padding: 5px;

        &:first-child{
          margin-top: 0;
        }

        &:last-child{
          margin-bottom: 0;
        }
      }

      @include responsive(mobile) {
        margin: 5px 0;
      }

      &:hover{
        border: 2px solid $black;
      }

      &.active, &.active:hover{
        border: 2px solid $primary;
      }

      &.picture-load{
        background-color: darken(#f9f9f9, 3%);
        border: none;

        &:hover{
          border: none;
        }
      }

      img{
        display: inline-block;
        max-width: 36px;
        max-height: 36px;
        width: auto;
        height: auto;
        vertical-align: middle;
        @include transform(translateX(-1px) translateY(-2px));

        @include responsive(mobile) {
          max-width: 26px;
          max-height: 26px;
        }
      }
    }
  }

  .product-colors{
    grid-column: span 2;
    margin-top: 10px;
    margin-bottom: 30px;
    display: none;

    @include responsive(mobile){
      display: block;
      order: 3;
    }

    ul{
      text-align: center;

      li.color{
        display: inline-block;
        background-color: $red;
        width: 30px;
        height: 30px;
        margin: 0 5px;
        float: none;
        @include radius(100%);

        &.active{
          position: relative;

          span.check{
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 1px;
            left: 0;

            &:after{
              display: block;
              content: '\e95f';
              font-family: 'welcom';
              position: absolute;
              font-size: 14px;
              text-align: center;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              line-height: 28px;
            }
          }
        }
      }
    }
  }
}
</style>
